import { CheckCircle, XCircle } from 'lucide-react'

export interface CreationResult {
  email: string
  name: string
  success: boolean
  error?: string
}

interface BatchResultsProps {
  results: CreationResult[]
  progress: number
  isRunning: boolean
}

export default function BatchResults({ results, progress, isRunning }: BatchResultsProps) {
  if (results.length === 0) return null
  const successCount = results.filter(r => r.success).length
  const errorCount = results.filter(r => !r.success).length

  return (
    <div className="space-y-3">
      <div className="flex items-center gap-4">
        {isRunning && (
          <div className="flex-1">
            <div className="h-2 bg-gray-200 rounded-full overflow-hidden">
              <div className="h-full bg-[#0055A4]/50 rounded-full transition-all" style={{ width: `${progress}%` }} />
            </div>
            <p className="text-xs text-gray-500 mt-1">{progress}% completado</p>
          </div>
        )}
        {!isRunning && (
          <div className="flex items-center gap-4 text-sm">
            <span className="flex items-center gap-1 text-green-700">
              <CheckCircle className="w-4 h-4" /> {successCount} creados
            </span>
            {errorCount > 0 && (
              <span className="flex items-center gap-1 text-red-700">
                <XCircle className="w-4 h-4" /> {errorCount} errores
              </span>
            )}
          </div>
        )}
      </div>

      {results.filter(r => !r.success).map((r, i) => (
        <div key={i} className="flex items-center gap-2 p-2 bg-red-50 text-red-700 rounded text-sm">
          <XCircle className="w-4 h-4 shrink-0" />
          <span><strong>{r.email}</strong>: {r.error}</span>
        </div>
      ))}
    </div>
  )
}
